import { Box, Stack } from '@mui/material';

import { useEligibilityCardState } from '../../hooks/useEligibilityCardState';
import { EligibilityCheckCard } from '../EligibilityCheckCard';

import { EligibilityBlock } from './EligibilityBlock';

interface BillingTabProps {
  patientId: string;
  encounterId?: string;
  onEditPatientInfo?: () => void;
}

export function BillingTab({ patientId, encounterId, onEditPatientInfo }: BillingTabProps) {
  const { state } = useEligibilityCardState({ patientId, encounterId });

  return (
    <Box sx={{ mt: 2 }}>
      <Stack spacing={2}>
        {state !== 'check_complete' && (
          <EligibilityCheckCard patientId={patientId} encounterId={encounterId} onEditPatientInfo={onEditPatientInfo} />
        )}

        {state === 'check_complete' && (
          <EligibilityBlock
            patientId={patientId}
            encounterId={encounterId}
            defaultCollapsed={false}
          />
        )}
      </Stack>
    </Box>
  );
}
